/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const CardInfo = ({ className, title, body }) => (
    <Card className={`margin-top card-border-3 card-info ${className}`}>
        <CardContent>
            <div className="card-title">{title}</div>
            {body}
        </CardContent>
    </Card>
);

CardInfo.defaultProps = {
    title: '',
    body: '',
    className: '',
};

CardInfo.propTypes = {
    title: PropTypes.object,
    body: PropTypes.object,
    className: PropTypes.string,
};

export default CardInfo;
